@if (_showLoading) {
  <div class="spinner-container">
    <div class="spinner">Loading...</div>
  </div>
}